import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';

import RouteWrapper from './route';

import Login from '../pages/Login';
import CalendarPage from '../pages/Calendar';
import AdminAbsencesReport from '../components/FullCalendar/AdminAbsencesReport';
import UsuariosPage from '../pages/Usuarios';
import CategoriasPage from '../pages/Categorias';
import MeusEventosPage from '../pages/MeusEventos';

const router = createBrowserRouter([
  // Rota de Login (pública)
  {
    path: '/login',
    element: <Login />,
  },
  // Redirect "/" para "/calendar"
  {
    path: '/',
    element: <Navigate to="/calendar" replace />,
  },
  // Rota da Agenda (protegida)
  {
    element: <RouteWrapper />,
    children: [
      {
        path: '/calendar',
        element: <CalendarPage />,
      },
      {
        path: '/meus-eventos',
        element: <MeusEventosPage />,
      },
      {
        path: '/reports',
        element: <AdminAbsencesReport />,
      },
      {
        path: '/usuarios',
        element: <UsuariosPage />,
      },
      {
        path: '/categorias',
        element: <CategoriasPage />,
      },
    ],
  },
  // Catch-all: qualquer outra rota vai pro login
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
]);

const RoutesList = () => {
  return <RouterProvider router={router} />;
};

export default RoutesList;
